export default __webpack_public_path__ + "static/media/team-2@2x.81cc0a4f.png";